import type { User } from "@/types/api";

export interface IdentityOption {
  key: string;
  label: string;
  color: string;
  textColor: string;
}

export const IDENTITY_OPTIONS: IdentityOption[] = [
  { key: "cris", label: "Preto + Accent", color: "#111111", textColor: "#d9ed09" },
  { key: "marinho", label: "Azul-marinho", color: "#1e40af", textColor: "#ffffff" },
  { key: "magenta", label: "Magenta", color: "#be185d", textColor: "#ffffff" },
  { key: "violeta", label: "Violeta", color: "#6d28d9", textColor: "#ffffff" },
  { key: "teal", label: "Teal", color: "#0f766e", textColor: "#ffffff" },
  { key: "laranja", label: "Laranja", color: "#c2410c", textColor: "#ffffff" },
  { key: "verde", label: "Verde", color: "#166534", textColor: "#ffffff" },
  { key: "vinho", label: "Vinho", color: "#7f1d1d", textColor: "#ffffff" },
  { key: "slate", label: "Slate", color: "#334155", textColor: "#ffffff" },
  { key: "ocre", label: "Ocre", color: "#a16207", textColor: "#111111" },
];

export const DEFAULT_IDENTITY_COLOR = "#111111";
export const DEFAULT_IDENTITY_TEXT_COLOR = "#d9ed09";

export function userIdentityColors(user?: Pick<User, "identity_color" | "identity_text_color"> | null) {
  return {
    backgroundColor: user?.identity_color ?? DEFAULT_IDENTITY_COLOR,
    color: user?.identity_text_color ?? DEFAULT_IDENTITY_TEXT_COLOR,
  };
}
